import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Avatar,
  Paper,
  Grid,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from '@mui/icons-material/Edit';
import { getUserProfile, updateName, updateProfilePicture } from "../api/user";
import { toast, ToastContainer } from "react-toastify";
const Profile = () => {
  const [profile, setProfile] = useState({});
  const [file, setFile] = useState(null); // For raw file object
  const [fileImg, setImgFile] = useState(null); // For preview or base64
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
  });
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Store the raw file
      const base64 = await convertToBase64(selectedFile); // Convert to base64 for preview
      setImgFile(base64);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const fetchProfileData = async () => {
    const { data } = await getUserProfile();
    const nameParts = data?.name.split(" ");
    const first_name = nameParts[0];
    const last_name = nameParts.slice(1).join(" ");
    setProfile({ ...data, first_name, last_name });
    setFormData({ first_name, last_name });
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleUpdateProfile = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const { data } = await updateProfilePicture(formData);
      toast.success(data?.message || "Error occurred");
    } catch (error) {
      toast.error("Error Occured");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = async () => {
    if (!formData?.first_name || !formData?.last_name) {
      toast.error("First Name and Last Name are required");
      return;
    }

    try {
      const { data } = await updateName({
        new_name: `${formData?.first_name} ${formData?.last_name}`,
      });
      toast.success(data?.message || "Error occurred"); 
    } catch (error) {
      toast.error("Error Occured");
    }

    if (file) {
      await handleUpdateProfile();
    }
  };

  return (
    <Box sx={{ padding: 3, flexGrow: 1, height: "90vh", overflow: "auto" }}>
      <Box
        sx={{
          paddingLeft: "10px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          marginBottom: 2,
          height: "80px",
          backgroundColor: "#FFF",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <AccountCircleIcon />
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Profile
        </Typography>
      </Box>

      <Box>
        <Paper
          sx={{
            padding: "40px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
          }}
        >
          <Typography sx={{ color: "#777", marginBottom: 4 }}>
            Tailor your chat experience to reflect your unique style and
            preferences with our Personalization settings.
          </Typography>

          <Grid container spacing={4} flexDirection={"column"}>
            <Grid
              item
              xs={12}
              sm={3}
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"center"}
              gap={"20px"}
            >
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".jpg, .png"
                onChange={handleFileChange}
              />
              <Box sx={{ position: 'relative' }}>
                <Avatar
                  src={fileImg || profile?.profile_picture}
                  sx={{
                    width: 120,
                    height: 120,
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    borderRadius: '50%',
                    padding: '8px',
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    }
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <EditIcon sx={{ color: 'white', fontSize: '20px' }} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={9}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="First Name"
                    placeholder="First Name"
                    variant="outlined"
                    fullWidth
                    name="first_name"
                    value={formData?.first_name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Last Name"
                    placeholder="Last Name"
                    variant="outlined"
                    fullWidth
                    name="last_name"
                    value={formData?.last_name}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Box marginTop={3}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    paddingX: 4,
                    paddingY: 1,
                    fontWeight: "600",
                    fontSize: "14px",
                    backgroundColor: "#161ab3",
                  }}
                  onClick={handleSaveChanges}
                >
                  Save Changes
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <ToastContainer />
    </Box>
  );
};

export default Profile;
